<template>
  <edit-modal
    caption="Voeg een bundel toe aan het account"
    :isActive="isActive">
    <div class="field">
      <div class="control">
        <select-wrapper
          :value="bundleId"
          :options="myBundles"
          @input="update"
          placeholder="Selecteer een bundel">
      </select-wrapper>
      </div>
    </div>

    <save-buttons
      @save="save"
      @cancel="close"
      :disabled="!valid">
    </save-buttons>
  </edit-modal>
</template>

<script>
import { bus } from '@/main'
import { mapGetters } from 'vuex'
import EditModal from '@/components/modules/EditModal'
import SaveButtons from '@/components/modules/SaveButtons'
import SelectWrapper from '@/components/wrappers/SelectWrapper'

export default {
  components: {
    EditModal,
    SaveButtons,
    SelectWrapper
  },
  data () {
    return {
      itemId: null,
      bundleId: null,
      isActive: false
    }
  },
  computed: {
    ...mapGetters({
      bundles: 'bundles/bundles'
    }),
    myBundles () {
      return this.bundles.map((bundle) => {
        return {
          label: bundle.name,
          value: bundle.id
        }
      })
    },
    valid () {
      return this.bundleId !== null
    }
  },
  created () {
    bus.$on('selectBundle', (payload) => {
      this.itemId = payload
      this.open()
    })
  },
  methods: {
    open () {
      this.isActive = true
    },
    close () {
      this.itemId = this.bundleId = null
      this.isActive = false
    },
    save () {
      this.$store.dispatch('items/include', {
        itemId: this.itemId,
        bundleId: this.bundleId
      })

      this.close()
    },
    update (bundleId) {
      this.bundleId = bundleId
    }
  }
}
</script>

<style scoped>
  p.select, select {
     width: 100%;
  }
</style>
